import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class FaqAccessGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state && state.url && state.url.indexOf('/faq') === 0) {
    this.router.navigateByUrl('/faq-not-found', { skipLocationChange: true });
    return false;
  }
   return true;
}
}
